export default __webpack_public_path__ + "static/media/firewood.4fc5789f.jpg";